import React, { useState, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ggAuth from 'ggApp/modules/auth';
import RedirectFormUI from './RedirectFormUi';
import { PaymentSdkContext } from '../state/paymentSdkContext';

const mapStateToProps = createStructuredSelector({
    user: ggAuth.selectors.user,
});

const RedirectForm = ({
    gateway,
    user,
    uiComponent,
    onPaymentMethodCreated,
    setPaymentTermsInfo,
}) => {
    const sdkInstance = useContext(PaymentSdkContext);
    const [isFormSubmitting, setFormSubmittingState] = useState(false);
    const [formErrorState, setFormErrorState] = useState(null);

    const handleSubmit = useCallback(
        (event) => {
            setFormSubmittingState(true);

            sdkInstance
                .createPaymentMethod(gateway, user.id)
                .then(({ checkoutUrl }) => {
                    onPaymentMethodCreated({
                        redirect: {
                            url: checkoutUrl,
                            gatewayType: gateway.type,
                        },
                    });
                })
                .catch(() => {
                    setFormErrorState('REDIRECT_FORM_ERROR_GENERAL');
                    setFormSubmittingState(false);
                });

            event.preventDefault();
        },
        [sdkInstance, gateway, user, onPaymentMethodCreated],
    );

    const RedirectFormUiComponent = uiComponent || RedirectFormUI;

    return (
        <form onSubmit={handleSubmit}>
            <RedirectFormUiComponent
                gateway={gateway}
                isFormSubmitting={isFormSubmitting}
                formErrorState={formErrorState}
                setPaymentTermsInfo={setPaymentTermsInfo}
            />
        </form>
    );
};

RedirectForm.propTypes = {
    gateway: PropTypes.shape({
        name: PropTypes.string,
    }).isRequired,
    onPaymentMethodCreated: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(RedirectForm);
